import { render, staticRenderFns } from "./EditWebResourceDialog.vue?vue&type=template&id=2d0a112e&scoped=true"
import script from "./EditWebResourceDialog.vue?vue&type=script&lang=ts"
export * from "./EditWebResourceDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditWebResourceDialog.vue?vue&type=style&index=0&id=2d0a112e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0a112e",
  null
  
)

export default component.exports